import axios from 'axios';
import clientConfig from '../client-config';
import setAuthToken from '../utils/setAuthToken';

export async function getUserProfile() {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  if (localStorage.token) {
    let res;
    try {
      res = await axios.get(clientConfig.backendHOST + '/user/UserProfile');
    } catch (e) {
      console.error(e);
    }

    if (res) {
      if (res.status === 200) {
        let tmpaddressId = '';
        let tmpcountry = '';
        let tmpzip = '';
        let tmpcity = '';
        let tmpstreet = '';
        let tmpphone1 = '';
        let tmpphone2 = '';
        let tmpbank = '';
        let tmpcomment = '';
        let tmptaxInvoice = '';
        let tmpcompanyName = '';
        let tmptaxNumber = '';
        let tmptaxZip = '';
        let tmptaxCity = '';
        let tmptaxStreet = '';

        if (res.data.userAddresses.length > 0) {
          tmpaddressId = res.data.userAddresses[0].addressId;
          tmpcountry = res.data.userAddresses[0].country;
          tmpzip = res.data.userAddresses[0].zip;
          tmpcity = res.data.userAddresses[0].city;
          tmpstreet = res.data.userAddresses[0].street;
          tmpphone1 = res.data.userAddresses[0].phone1;
          tmpphone2 = res.data.userAddresses[0].phone2;
          tmpbank = res.data.userAddresses[0].bankAccountNr;
          tmpcomment = res.data.userAddresses[0].comment;
          tmptaxInvoice = res.data.userAddresses[0].taxInvoice;
          tmpcompanyName = res.data.userAddresses[0].companyName;
          tmptaxNumber = res.data.userAddresses[0].taxNumber;
          tmptaxZip = res.data.userAddresses[0].taxZip;
          tmptaxCity = res.data.userAddresses[0].taxCity;
          tmptaxStreet = res.data.userAddresses[0].taxStreet;
        }
        return {
          isOk: true,
          Profile: {
            userId: res.data.userId,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            email: res.data.email,
            oldAddressId: tmpaddressId,
            country: tmpcountry,
            zip: tmpzip,
            city: tmpcity,
            street: tmpstreet,
            phone1: tmpphone1,
            phone2: tmpphone2,
            bankAccountNr: tmpbank,
            comment: tmpcomment,
            taxInvoice: tmptaxInvoice,
            companyName: tmpcompanyName,
            taxNumber: tmptaxNumber,
            taxZip: tmptaxZip,
            taxCity: tmptaxCity,
            taxStreet: tmptaxStreet,
          },
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}

export async function saveUserProfile(userData) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.post(
        clientConfig.backendHOST + '/user/UserProfile',
        userData,
        config
      );
    } catch (e) {
      console.error('error', e);
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}
